import React from 'react'
import s from './GeoentityBlockServiceList.less'
import classNames from 'classnames'
import { checkBlockAspectFitsWhitelist } from './GeoentityBlockUtils'

export default function GeoentityBlockServiceList({ data }) {
  const { list } = data
  const aspect = data.aspect

  if (!checkBlockAspectFitsWhitelist(['mappy_picto', 'image'], data)) return null

  return (
    <div className={classNames(aspect === 'mappy_picto' && s.mappy_picto)}>
      {list.map(({ label, imageUrl }, idx) => (
        <div key={idx} className={s.item}>
          <img className={s.image} src={imageUrl} />
          <span className={s.text}>{label}</span>
        </div>
      ))}
    </div>
  )
}
